
class BankAccountCell extends UITableViewCell
{
    private numberLabel:MUILabel = null;
    private ibanLabel:MUILabel = null;
    private currencyLabel:MUILabel = null;
    private titleLabel:MUILabel = null;
    private balanceLabel:MUILabel = null;


    awakeFromHTML(){
        this.numberLabel = MUIOutlet(this, "number-lbl", "MUILabel");
        this.ibanLabel = MUIOutlet(this, "iban-lbl", "MUILabel");
        this.currencyLabel = MUIOutlet(this, "currency-lbl", "MUILabel");
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
        this.balanceLabel = MUIOutlet(this, "balance-lbl", "MUILabel");
    }

    set item (item:BankAccount){
        this.numberLabel.text = item.info?.number;
        this.ibanLabel.text = item.info?.iban;
        this.currencyLabel.text = "EUR" // item.info?;
        this.titleLabel.text = item.info?.title;
        this.balanceLabel.text = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.stringFromNumber( item.balance );
    }

}